<template>
  <v-container fluid>
    <v-layout row justify="space-between" class="mb-2">
      <v-flex>
        <router-link :to="{ name: 'myTodoList' }">
          <v-btn color="primary">
            Go to my task list
          </v-btn>
        </router-link>
      </v-flex>
      <v-flex class="text-xs-right">
        <v-btn :to="{ name: 'taskReport' }" color="primary">
          <v-icon left>
            table_chart
          </v-icon>
          Tasks Report
        </v-btn>
      </v-flex>
    </v-layout>

    <v-layout row align-center>
      <v-flex>
        <h1 class="display">
          <span v-if="selectedUser && selectedUser.display_name">
            {{ selectedUser.display_name }}'s
          </span>
          <span v-else>
            All Managed
          </span>
          Tasks
        </h1>
      </v-flex>
      <v-flex class="text-xs-right">
        <NewTaskDialog
          :managed="true"
          :forUserID="selectedUser ? selectedUser.id : null"
        />
      </v-flex>
    </v-layout>

    <v-layout row>
      <v-flex class="mr-2">
        <v-autocomplete
          label="Employee"
          :items="employeeFilters"
          item-text="name"
          item-value="id"
          return-object
          v-model="selectedUser"
          @change="updateRoute"
          :loading="employeesLoading"
          :disabled="employeesLoading"
          clearable
        />
      </v-flex>
      <v-flex>
        <v-autocomplete
          label="Manager"
          :items="managerFilters"
          item-text="name"
          item-value="id"
          return-object
          v-model="selectedUser"
          @change="updateRoute"
          :loading="managersLoading"
          :disabled="managersLoading"
          clearable
        />
      </v-flex>
    </v-layout>

    <v-layout row>
      <v-flex class="mr-2">
        <v-switch label="Show automated" v-model="showAutomated" />
      </v-flex>
    </v-layout>

    <v-layout row v-if="overdue.length > 0" class="mb-4">
      <v-flex xs12>
        <v-alert icon="timer" type="warning" :value="true">
          <h2 class="title">Overdue</h2>
        </v-alert>

        <v-progress-linear v-if="tasksLoading" indeterminate />
        <v-data-iterator
          :items="overdue"
          column
          content-tag="v-layout"
          :rows-per-page-items="[10]"
          :hide-actions="overdue.length <= 10"
        >
          <template v-slot:item="props">
            <v-flex xs12 class="pa-1">
              <TodoItem :item="props.item" :managed="true" />
            </v-flex>
          </template>
        </v-data-iterator>
      </v-flex>
    </v-layout>

    <v-layout column>
      <v-tabs grow icons-and-text v-model="tab" dark>
        <v-tabs-slider></v-tabs-slider>
        <v-tab>
          Upcoming
          <v-icon>inbox</v-icon>
        </v-tab>

        <v-tab>
          Done Recently
          <v-icon>check_circle</v-icon>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-progress-linear v-if="tasksLoading" indeterminate />
              <v-data-iterator
                :items="upcomingItems"
                column
                content-tag="v-layout"
                :rows-per-page-items="[-1]"
                hide-actions
              >
                <template v-slot:item="props">
                  <v-flex xs12 class="pa-1">
                    <TodoItem :item="props.item" :managed="true" />
                  </v-flex>
                </template>
              </v-data-iterator>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-data-iterator
                :items="doneItems"
                column
                content-tag="v-layout"
                :rows-per-page-items="[10]"
              >
                <template v-slot:item="props">
                  <v-flex xs12 class="pa-1">
                    <TodoItem :item="props.item" :managed="true" />
                  </v-flex>
                </template>
              </v-data-iterator>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import TodoItem from "./todo-item.vue";
import NewTaskDialog from "./new-todo-item-dialog.vue";
import collectionApi from "@/api/collections.js";

export default {
  components: {
    TodoItem,
    NewTaskDialog
  },
  data() {
    return {
      tab: 0,
      tasksLoading: false,
      employeesLoading: false,
      managersLoading: false,
      selectedUser: {},
      employeeFilters: [],
      managerFilters: [],
      showAutomated: false,
      pendingID: null,
      pagination: {
        // sortBy: 'due_on',
        // descending: true,
        rowsPerPage: 10
      },
      headers: [
        {},
        {
          text: "Due",
          value: "due_on"
        },
        {
          text: "Task",
          value: "description"
        }
      ]
    };
  },
  watch: {
    //selectedUser(user) {
    //if (user) {
    ////this.tasksLoading = true
    ////this.$store.dispatch('todos/getManaged', user.id)
    ////.then((t) => {
    ////this.tasksLoading = false
    ////})
    //this.$router.replace({
    //name: 'managedTodoLists',
    //query: { userID: user.id }
    //})
    //} else {
    //this.tasksLoading = true
    //this.$store.dispatch('todos/getManaged')
    //.then((t) => {
    //this.tasksLoading = false
    //})
    //}
    //},
  },
  computed: {
    ...mapState("todos", ["items"]),
    undoneItems() {
      return this.items.filter(t => {
        if (!t.done) {
          return t;
        }
      });
    },
    doneItems() {
      const items = this.items.filter(t => {
        if (t.done) {
          return t;
        }
      });

      const sorted = _.orderBy(items, ["done_on"], ["desc"]);
      return sorted;
    },

    overdue() {
      return this.items.filter(t => {
        const now = this.$moment();
        if (!t.done && t.due_on && this.$moment(t.due_on).isBefore(now)) {
          return t;
        }
      });
    },
    upcomingItems() {
      const items = this.items.filter(t => {
        const now = this.$moment();
        if (!t.done && !this.overdue.map(t => t.id).includes(t.id)) {
          return t;
        }
      });
      const filtered = items.filter(t => {
        if (this.showAutomated) {
          return t;
        } else {
          if (t.task_type == "standard") {
            return t;
          }
        }
      });
      // Sort by due first, then created_at
      const sorted = _.orderBy(
        filtered,
        ["due_on", "created_at"],
        ["asc", "asc"]
      );
      return sorted;
    }
  },
  mounted() {
    const e = this.getEmployees();
    const m = this.getManagers();
    Promise.all([e, m]).then(r => {
      this.getTasks();
    });
  },

  methods: {
    updateRoute() {
      if (this.selectedUser) {
        this.$router.replace({
          name: "managedTodoLists",
          query: { userID: this.selectedUser.id }
        });
      } else {
        this.$router.replace({
          name: "managedTodoLists"
        });
      }
    },

    getTasks() {
      this.tasksLoading = true;
      if (this.$route.query.userID) {
        const userID = this.$route.query.userID;
        this.selectedUser = this.employeeFilters.find(e => userID == e.id);
        if (!this.selectedUser) {
          this.selectedUser = this.managerFilters.find(e => userID == e.id);
        }
        this.$store.dispatch("todos/getManaged", userID).then(t => {
          this.tasksLoading = false;
        });
      } else {
        this.$store.dispatch("todos/getManaged").then(t => {
          this.tasksLoading = false;
        });
      }
    },

    getEmployees() {
      this.employeesLoading = true;
      return new Promise(resolve => {
        collectionApi.getEmployees(employees => {
          this.employeeFilters = employees;
          this.employeesLoading = false;
          resolve();
        });
      });
    },
    getManagers() {
      this.managersLoading = true;
      return new Promise(resolve => {
        collectionApi.getManagersList({ includeBoh: true }, managers => {
          this.managerFilters = managers;
          this.managersLoading = false;
          resolve();
        });
      });
    },

    itemPending(itemID) {
      if (this.pendingID === itemID) {
        return true;
      }
      return false;
    }
  }
};
</script>
